module.exports = __webpack_public_path__ + "fonts/Clash-Heavy.a27c231.woff2";